import Drawer from "../../../../drawer/Drawer";
import ManageDiscount from "../ManageDiscount";

const ManageDiscountDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Discount" : "Add Discount"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageDiscount getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageDiscountDrawer;
